export default __webpack_public_path__ + "static/media/change_font_more_readable.75fb4b0f.svg";